import { css } from 'emotion'

export const UpdateAvatarFormStyles = css``
